import "./Logo.css";

function Logo() {
  return (
    <div className="logoo-container">
      <img src="./to.gif" alt="" className="one-img" />
      <h1> tasks</h1>
      <img src="./robot.gif" alt="" className="two-img" />
    </div>
  );
}

export default Logo;
